module.exports = __webpack_public_path__ + "static/media/telealignbottom.5d6a709b.svg";